export enum WoundType {
  WoundNotExist = 0,
  WoundExist = 1,
}

export enum WoundCategoryType {
  Initial = 0,
  FollowUp = 1,
}

export enum WoundStatus {
  Created = 0,
  WaitingDoctorAssignment = 1,
  DoctorAssigned = 2,
  TreatmentDecisionCreated = 3,
  TreatmentCompleted = 4,
  Processing = 5,
}

export interface WoundListItem {
  id: string;
  name: string | null;
  description: string | null;
  woundStatus: number;
  woundCategoryType: number;
  woundType: number;
  lidarPath: string | null;
  imagePathOne: string | null;
  imagePathTwo: string | null;
  imagePathThree: string | null;
  bsnNumber?: string;
  createdDate?: string;
  isProcessing?: boolean;
  isConsultation?: boolean;
  consultationStatus?: number;
  hasWound?: boolean;
}

export interface PatientWoundListItem {
  patientId: string;
  patientName: string;
  patientOrganizationId?: string;
  bsnNumber?: string;
  createdDate?: string;
  wounds: WoundListItem[];
}

export interface WoundListResponse {
  items: PatientWoundListItem[];
  index: number;
  size: number;
  count: number;
  pages: number;
  hasPrevious: boolean;
  hasNext: boolean;
}

export interface CreateWoundResponse {
  id: string;
}

export interface GetListWoundByPatientIdResponse {
  id: string;
  createdDateTime: Date;
  woundStatus: number;
  woundCategoryType: number;
  woundType: number;
  isActive: boolean;
  parentWoundId?: string;
  followUps?: FollowUpWound[];
  doctorId?: string;
  doctorName?: string;
}

export interface FollowUpWound {
  id: string;
  name: string | null;
  description: string | null;
  woundStatus: number;
  woundCategoryType: number;
  woundType: number;
  lidarPath: string | null;
  imagePathOne: string | null;
  imagePathTwo: string | null;
  imagePathThree: string | null;
  isActive: boolean;
  treatmentPlannedDate: Date;
  treatmentCompletedDate: Date;
  recordId: string;
  doctorDecision: any | null;
  woundNotes: any[];
  createdDateTime: Date;
}

export interface GetWoundByIdResponse {
  id: string;
  name: string | null;
  description: string | null;
  woundStatus: number;
  woundCategoryType: number;
  woundType: number;
  didAskToDoctor: boolean;
  lidarPath: WoundFileDto | null;
  imagePathOne: WoundFileDto | null;
  imagePathTwo: WoundFileDto | null;
  imagePathThree: WoundFileDto | null;
  isActive: boolean;
  isProcessing?: boolean;
  treatmentPlannedDate: Date;
  treatmentCompletedDate: Date;
  doctorAnswer: DoctorAnswerDto | null;
  doctorDecision: DoctorDecisionDto | null;
  recordId: string;
  doctorId: string | null;
  doctorName: string | null;
  parentWoundId: string | null;
  woundNotes: WoundNoteDto[];
  woundAssessments: WoundAssessmentsDto[];
  // 3D Analysis results
  paintedModelPath?: string | null;
  overlayModelPath?: string | null;
  woundPatchPath?: string | null;
  metricsPath?: string | null;
}

export interface WoundAnalysisMetrics {
  surfaceAreaMm2: number;
  surfaceAreaCm2: number;
  volumeMm3: number;
  volumeCm3: number;
  volumeIsApproximate: boolean;
  isWatertight: boolean;
  boundingBoxMm?: number[];
  centroidMm?: number[];
  boundaryLengthMm: number;
  numVertices: number;
  numFaces: number;
  steepestViewOriginalPath?: string | null;
  steepestViewSegmentedPath?: string | null;
}

export interface DoctorAnswerDto {
  id: string;
  answer: string;
  createdDate: Date;
}

export interface DoctorDecisionDto {
  id: string;
  decision: string;
  createdDate: Date;
}

export interface WoundNoteDto {
  id: string;
  note: string;
  createdDate: Date;
  userName: string;
}

export interface WoundAssessmentsDto {
  id: string;
  assessedAt: Date;
  assesedByUserId: string;
  woundAssessmentQuestions: WoundAssessmentQuestionDto[];
  woundAssessmentRiskCategories: WoundAssessmentRiskCategoryDto[];
}

export interface WoundAssessmentQuestionDto {
  id: string;
  assessmentTemplateId: string;
  assessmentTemplateName: string;
  woundAssessmentAnswers: WoundAssessmentAnswerDto[];
}

export interface WoundAssessmentAnswerDto {
  id: string;
  assessmentQuestionId: string;
  questionText: string;
  assessmentAnswerOptionId: string;
  answerText: string;
}

export interface WoundAssessmentRiskCategoryDto {
  id: string;
  assessmentTemplateId: string;
  assessmentTemplateCode: string;
  totalScore: number;
  riskCategoryName: string;
  description: string;
  metadata?: string;
}

export interface PatientForApproveDto {
  id: string;
  name?: string;
}

export interface GetWoundAssignDoctorDto {
  id: string;
  doctorId: string;
  doctorName: string;
}

export interface WoundForApproveDto {
  id: string;
  name?: string;
  description?: string;

  woundStatus: number;
  woundCategoryType: number;
  woundType: number;

  lidarPath?: string;
  imagePathOne?: string;
  imagePathTwo?: string;
  imagePathThree?: string;

  isActive: boolean;
  assignDoctors: GetWoundAssignDoctorDto[];
}

export interface WoundApprovalItemDto {
  patient: PatientForApproveDto;
  wound: WoundForApproveDto;
}

export interface WoundFileDto {
  path: string;
  notes: WoundModelNoteDetailDto[];
}

export interface WoundModelNoteDetailDto {
  id: string;
  markerType: number;
  positionData: string;
  note: string;
}

export interface WoundHistoryResponse {
  id: string;
  imagePathOne: WoundFileDto | null;
  imagePathTwo: WoundFileDto | null;
  imagePathThree: WoundFileDto | null;
  lidarPath: WoundFileDto | null;
}

export interface GetWoundHistoryResponseItem {
  woundId: string;
  woundStatus: number;
  createdDate: Date | null;
  completedDate: Date | null;
  statusMessage: string | null;
  doctorDescription: string | null;
  doctorTreatments: string[];
  nurseNote: string | null;
}
